import {React} from 'react'
import '../styles/call.css'

function Call() {

  return (
    <div className='call-container'>


        <div className="call-text">
            <h2>Request a quote from us</h2>
        </div>
        <div className="call-button">
            <button> <a href='/Quote'>Get a Free Quote</a></button>
        </div>
        
    </div>
  )
}

export default Call